import $ from 'jquery';
window.$ = $;
window.process = {
	env: { DEBUG: undefined },
};

import './content_card';
import './pdf_viewer';
import '../scss/main.scss';

